var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 57.1 44",
    style: {
      enableBackground: "new 0 0 57.1 44"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M56.9,3.7c0-1.8-1.5-3.3-3.3-3.3c-1.8,0-3.3,1.5-3.3,3.3c0,1,0.5,1.9,1.2,2.6c-1.8,4.3-4.7,6.6-6.9,7.8 c-0.3,0.2-0.7,0.3-1,0.5c-3-3.7-7.7-6-12.9-5.3c-7.2,0.9-12.6,6.9-12.6,14c-4.9,1.3-8.7,0.1-11.1-1.1c0-0.1,0-0.2,0-0.3 c0-1.8-1.5-3.3-3.3-3.3c-1.8,0-3.3,1.5-3.3,3.3c0,1.8,1.5,3.3,3.3,3.3c0.6,0,1.2-0.2,1.7-0.5c1.7,0.9,4.1,1.8,7,2.1 c0.7,0.1,1.4,0.1,2.1,0.1c1.2,0,2.5-0.2,3.9-0.5c1.3,7.3,8.1,12.1,15.7,11.2c7.9-0.9,13.4-8,12.5-15.9c-0.2-1.8-0.6-3.1-1.3-4.5 c2.8-1.3,7-4.2,9.2-10.1C55.8,6.5,56.9,5.2,56.9,3.7z M32.9,29.9c-3.6,0.4-6.8-2.1-7.2-5.7c-0.4-3.6,2.1-6.8,5.7-7.2 c3.6-0.4,6.8,2.1,7.2,5.7C39,26.2,36.4,29.4,32.9,29.9z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPins);
export default __webpack_public_path__ + "static/media/pins.9ab8c03e1a4c44534900a9d386f221c6.svg";
export { ForwardRef as ReactComponent };